export enum ENmdProductStatus {
  'Active' = 1,
  'InActive' = 2,
  'Deactivated' = 3,
  'NotAvailbleOnSelectedDataset' = 4,
  'InActiveDueToLabelSelection' = 5
}
